import React from "react";
import { useHistory } from "react-router-dom";
import { parseISO, format, isSameDay } from "date-fns";
import { green } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import {
	Avatar,
	Badge,
	Divider,
	ListItemAvatar,
	ListItem,
	ListItemText,
	Tooltip,
	Typography,
} from "@material-ui/core";
import SimCardOutlinedIcon from '@material-ui/icons/SimCardOutlined';

import MarkdownWrapper from "../MarkdownWrapper";
import truncateString from "../../utils/truncateString";
import whatsappIcon from '../../assets/ticketsTypes/whatsapp.png';
import WhatsappOfficialImg from "../../assets/miscJpg/whatsappOfficial.jpg";

import DefaultFunctionsUtils from "../../utils/classes/DefaultFunctionsUtils";
import DefaultValuesUtils from "../../utils/classes/DefaultValuesUtils";

import { useGlobalRegisters } from "../../context/GlobalRegisters/GlobalRegistersContext";

const useStyles = makeStyles(theme => ({
	svgIcons: { borderRadius:"20px", fontSize: "15px", },

	ticket: { borderRadius:"20px", position: "relative", },

	contactNameWrapper: { borderRadius: "20px", display: "flex", justifyContent: "space-between", },

	contactBadgeWrapper: {
		borderRadius: "20px",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		gap: "1.65em"
	},

	newBadge: { borderRadius: "20px", alignSelf: "center", marginRight: 8, marginLeft: "auto", },

	contactNameAndDevice: { display: "flex", flexDirection: "row", alignItems: "center", gap: "5px", },

	ticketType: { width: "20px", },

	lastMessageTime: { borderRadius:"20px", justifySelf: "flex-end", },

	badgeList: {
		borderRadius:"20px",
		adding: "3px",
		color: "#f6f6ff",
		fontSize: "10px",
		
		display: "flex",
		gap: "3px",
		alignItems: "center",
	},

	chipBadge: {
		border: `1px solid ${theme.palette.primary.main}`,
		padding: "3px",
		paddingLeft: "10px",
		paddingRight: "10px",
		borderRadius: "15px",
		color: theme.palette.text.primary,
		fontSize: "10px",
		width: "fit-content",
		marginRight: 0,
		marginLeft: "auto",

		display: "flex",
		gap: "3px",
		alignItems: "center",
		justifySelf: "flex-end",
	},

	contactLastMessage: { paddingRight: 20, width: "100%" },

	badgeStyle: { color: "white", backgroundColor: green[500], },
}));

const ContactViewListItem = ({ contactView, resetAudioPlayer }) => {
	// 	***************
	// 	** Variables **
	// 	***************
	const classes = useStyles();
	const history = useHistory();

  const contactViewKey = `${contactView.id}-${contactView.whatsappId}`;

	const {
		contactViewContactId
		, setContactViewContactId
		, contactViewWhatsappId
		, setContactViewWhatsappId
		, setShouldSyncRouteOnMenu
	} = useGlobalRegisters();



	// 	***************
	// 	** Functions **
	// 	***************
	const handleSelectContactView = (contactView) => {
		localStorage.setItem("selectedTicketContactId", contactView.id);
		localStorage.setItem("tabOpenTickets", "contactsView");

		const shouldResetAudioPlayer = localStorage.getItem("selectedTicketContactId") === localStorage.getItem("currentPlayingAudioContactId");
		if (shouldResetAudioPlayer) resetAudioPlayer();

		setContactViewContactId(contactView.id);
		setContactViewWhatsappId(contactView.whatsappId);

		DefaultFunctionsUtils.redirectToTicketsPage(history, `/${contactView.ticketId}?tab=open`);
		setShouldSyncRouteOnMenu(true);
	};



	// 	************
	// 	** Return **
	// 	************
  return (
    <React.Fragment key={contactViewKey}>
      <Tooltip
        arrow
        placement="left"
        title={contactView.name}
        PopperProps={{ disablePortal: true }}
      >
        <ListItem
          dense
          button
          onClick={() => handleSelectContactView(contactView)}
					onContextMenu={(event) => event.preventDefault()}
					selected={contactView.id === contactViewContactId && contactView.whatsappId === contactViewWhatsappId}
          className={classes.ticket}
          style={{ 
            "-webkit-box-shadow": "inset -3px -4px #7C7C7C",
            "-moz-box-shadow": "inset -3px -4px #7C7C7C",
            boxShadow: "inset -3px -4px #7C7C7C",
          }}
        >
          <ListItemAvatar>
            <Avatar src={contactView.name === DefaultValuesUtils.SPECIAL_NAMES.whatsapp ? WhatsappOfficialImg : contactView.profilePicUrl} />
          </ListItemAvatar>

          <ListItemText
            disableTypography
            primary={
              <span className={classes.contactNameWrapper}>
                <span className={classes.contactNameAndDevice}>
                  <img className={classes.ticketType} src={whatsappIcon} alt="Ticket Logo" />

                  <Typography component="span" variant="body2" color="textPrimary" style={{wordBreak: "break-word"}}>
                    {truncateString(contactView.name, 27)}
                  </Typography>
                </span>

                <Typography className={classes.lastMessageTime} component="span" variant="body2" color="textSecondary">
                  {isSameDay(parseISO(contactView.lastActivityAt), new Date())
                    ? (<>{format(parseISO(contactView.lastActivityAt), "HH:mm")}</>)
                    : (<>{format(parseISO(contactView.lastActivityAt), "dd/MM/yyyy")}</>)}
                </Typography>
              </span>
            }
            secondary={
              <span className={classes.contactBadgeWrapper}>
                <Typography className={classes.contactLastMessage} noWrap component="span" variant="body2" color="textSecondary">
                  <MarkdownWrapper shouldFormat={false}>{contactView.lastMessage}</MarkdownWrapper>

                  <div className={classes.badgeList}>
                    <div className={classes.chipBadge}>
                      <SimCardOutlinedIcon className={classes.svgIcons} /> {contactView.whatsappName}
                    </div>
                  </div>
                </Typography>

                <Badge
									className={classes.newBadge}
									classes={{ badge: classes.badgeStyle }}
									badgeContent={
										(() => {
											if (contactView.unreadMessages !== 0) return contactView.unreadMessages;
											else return contactView.isMarkedAsUnread ? "" : 0;
										})()
									}
								/>
              </span>
            }
          />

        </ListItem>
      </Tooltip>

      <Divider variant="inset" component="li" />
    </React.Fragment>
  );
};

export default ContactViewListItem;
